module.exports = __webpack_public_path__ + "static/media/ridesharing.ff7c3881.png";